import SignatureBaseRequest from '../SignatureBaseRequest'

export default class SignatureRequest extends SignatureBaseRequest {
  createSignature (params, headers) {
    return this.post('/create-signature', params, headers)
  }
  deleteSignature (id) {
    return this.delete(`/signature/${id}`)
  }
  signDocument (params) {
    return this.post('/sign-document', params)
  }
  getDoctorSignatures (params) {
    return this.get('/signatures', params)
  }
  signDocumentWithJson (params) {
    return this.post('/sign-json', params)
  }
  getSignProcedures (params) {
    return this.get('/sign_procedures', params)
  }
  createEnvelope (params) {
    return this.post('/sign_envelopes', params)
  }
  signDocumentWithEnvelope (params) {
    return this.post('/signing-process', params)
  }
  getEnvelopeDetailByDocumentID (params) {
    return this.get(`/sign_envelopes/by_doc`, params)
  }
  updateEnvelope (id, params) {
    return this.put(`sign_envelopes/${id}`, params)
  }
  getSignEnvelopeByDocumentID (params) {
    return this.get(`sign_envelopes/by_doc`, params)
  }
  sendNotiSignDocument (params) {
    return this.post('signing-process/send-sign', params)
  }
  getSignEnvelopeByID (id) {
    return this.get(`sign_envelopes/${id}`)
  }
  updateSignatoryMetadata (id, params) {
    return this.put(`/signatory_metadata/${id}`, params)
  }
  getListSignEnvelopes (params) {
    return this.get(`sign_envelopes`, params)
  }
  updateListSignatoryMetadata (params) {
    return this.post(`/signatory_metadata/multiple`, params)
  }
  signingDocumentWithSignatories (params) {
    return this.post('/signing-process/multiple-signatories', params)
  }
  getSignatureCryptoService (orgId) {
    return this.get(`/signature-crypto-services/${orgId}`)
  }
  // VNPT Smart CA
  getVnptCredentials (body) {
    return this.post('/smart-ca/credentials/get_certificate', body)
  }
  vnptRequestSign (body) {
    return this.post('/smart-ca/signatures/sign', body)
  }
  vnptSignInfo (body, tranId) {
    return this.post(`/smart-ca/signatures/sign-info/${tranId}`, body)
  }
  // IntrustCA
  loginIntrustCA (body) {
    return this.post('/intrust-ca/login', body)
  }
  loginIntrustCAWithRefreshToken () {
    return this.get('/intrust-ca/login-with-refresh-token')
  }
  getIntrustCertificates () {
    return this.get('/intrust-ca/certificates')
  }
  intrustSign (body) {
    return this.post('/intrust-ca/sign', body)
  }
  unlinkIntrustCAAccount () {
    return this.get('/intrust-ca/unlink')
  }
  registerSessionIntrustCAAccount (body) {
    return this.post('/intrust-ca/register_session', body)
  }
  createIntrustCACert (formData) {
    return this.post('/intrust-ca/hodo/ca_registration', formData)
  }
  getIntrustCARegistration () {
    return this.get('/intrust-ca/hodo/ca-registration')
  }
  getIntrustCAPackages () {
    return this.get('/intrust-ca/portal/packages')
  }
  getIntrustCAProvinces () {
    return this.get('/intrust-ca/portal/provinces')
  }
}
